import React, {useContext, useEffect, useState} from 'react'
import {Button, Space} from 'antd'
import {ReactComponent as RunIcon} from '../icons/Run.svg'
import {ReactComponent as ExportIcon} from '../icons/Export.svg'
import buttonStyles from '../../../components/common/styled/Buttons.module.scss'
import {useAppSelector} from '../../../hooks'
import {selectPermissions} from '../../../actions/userSlice'
import {emptyUserQuery, QueryBuilderContext, QueryBuilderContextType} from '../QueryBuilderContext'
import {QueryStatus} from '../../../containers/QueryBuilder/types/Query'
import {apiRunQuery} from '../../../containers/QueryBuilder/queryBuilderApi'
import {v4 as uuidV4} from 'uuid'
import ReactDOM from 'react-dom'
import styles from './QueryActions.module.scss'

import {rawContentHasEntries} from './ResultTable'

import ExportDialog from './ExportDialog'

const QueryActions = () => {

    const {
        id,
        setId,
        userQuery,
        setUserQuery,
        queryResult,
        setQueryResult,
        setDefaultQueryVisualisationOptions
    } = useContext(QueryBuilderContext) as QueryBuilderContextType

    const permissions = useAppSelector(selectPermissions)

    const [isExportModalOpen, setIsExportModalOpen] = useState(false)

    const [isQueryExportEnabled, setIsQueryExportEnabled] = useState(false)

    useEffect(() => {

        const {status} = userQuery

        if (status !== QueryStatus.FINISHED) {
            setIsQueryExportEnabled(false)
            return
        }

        if (status === QueryStatus.FINISHED) {

            if (!queryResult) {
                setIsQueryExportEnabled(false)
                return
            }

            if (queryResult.valueAvailable && rawContentHasEntries(queryResult)) {
                setIsQueryExportEnabled(true)
                return
            } else if ((!queryResult.valueAvailable && userQuery.errorMsg === 'DISPLAY_CAPACITY_EXCEEDED') || userQuery.largeExport) {
                setIsQueryExportEnabled(true)
            } else {
                setIsQueryExportEnabled(false)
            }
        }
    }, [queryResult, userQuery])

    const startQuery = () => {

        setDefaultQueryVisualisationOptions(undefined)

        const queryId = uuidV4()

        userQuery.query.filters = userQuery.query.filters.filter(filter => filter.code && filter.value)

        const {transformer, columns, rows, values, filters, filterLabels} = userQuery.query

        const query = {transformer, columns, rows, values, filters, filterLabels}

        const _userQuery = {...emptyUserQuery(), ...{status: QueryStatus.RUNNING}, ...{query: query}}

        apiRunQuery(queryId, query)
            .then(i => {
                ReactDOM.unstable_batchedUpdates(() => {
                    setId(queryId)
                    setUserQuery(_userQuery)
                    setQueryResult(undefined)
                })
            })
    }

    const canANewQueryBeRun = () => {
        return (
            userQuery.status === QueryStatus.READY ||
            (userQuery.status === QueryStatus.FINISHED && queryResult && queryResult?.message)
        )
    }

    return <>

        <div className={styles.queryActionGroupsContainer}>

            <Space size={12} align='center'>
                <Button className={`${buttonStyles['bluePrimary']}`}
                        type='primary'
                        disabled={!isQueryExportEnabled || !permissions?.csvExport}
                        data-testid='export-button'
                        icon={<ExportIcon/>}
                        onClick={() => {
                            setIsExportModalOpen(true)
                        }}
                >
                    &nbsp;&nbsp;Export
                </Button>

                <Button className={`${buttonStyles['greenPrimary']}`}
                        type='primary'
                        disabled={!canANewQueryBeRun()}
                        data-testid='run-query-button'
                        icon={<RunIcon/>}
                        onClick={() => startQuery()}>
                    &nbsp;&nbsp;Run
                </Button>

                <ExportDialog id={id}
                              queryDuration={Number(userQuery.totalTimes)}
                              queryResult={queryResult}
                              isOpen={isExportModalOpen}
                              hideExportModal={() => setIsExportModalOpen(false)}
                />
            </Space>

        </div>

    </>

}

export default QueryActions